import React, { useState, useEffect, useRef } from 'react';

// Material Resources
import {
  FormControl,
  FormHelperText,
  MenuItem,
  InputLabel,
  Grid,
  // Select,
} from '@material-ui/core';

// Others
import PropTypes from 'prop-types';
import { Select } from 'formik-material-ui';
import { ErrorMessage, useFormikContext } from 'formik';
// Styles & Images
import useStyles from './styles';
import CustomSelectMaterialCoreClient from './type-select/client-select';
import CustomSelectMaterialCoreAdmin from './type-select/admin-select';

function CustomSelectMaterialCore(props) {
  // data : Array of elements, example: [{ country_name: "Peru", country_val: "PE" }]
  // mapData: Define which object property use as value and label, example: {value: "country_val", label: "country_name"}
  // mapData default => {value: "value", label: "label"}
  const {
    id,
    disabled,
    name,
    label,
    data,
    mapData,
    onChange,
    error,
    isStepForm,
  } = props;

  // const [currentPath, setCurrentPath] = useState('');
  const [isAdminPath, setIsAdminPath] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;
    // setCurrentPath(path);

    if (path.includes('administrador')) {
      setIsAdminPath(true);
    } else {
      setIsAdminPath(false);
    }

    console.log('Current Path:', path);
    console.log('Is Admin Path:', isAdminPath);
  }, [isAdminPath]);
  return (
    <>
      {isAdminPath ? (
        <>
          <CustomSelectMaterialCoreAdmin
            id={id}
            disabled={disabled}
            name={name}
            label={label}
            data={data}
            mapData={mapData}
            onChange={onChange}
            error={error}
            isStepForm={isStepForm}
          />
        </>
      ) : (
        <>
          <CustomSelectMaterialCoreClient
            id={id}
            disabled={disabled}
            name={name}
            label={label}
            data={data}
            mapData={mapData}
            onChange={onChange}
            error={error}
            isStepForm={isStepForm}
          />
        </>
      )}
    </>
  );
}
CustomSelectMaterialCore.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  mapData: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isStepForm: PropTypes.bool,
  error: PropTypes.string,
};
CustomSelectMaterialCore.defaultProps = {
  mapData: { value: 'value', label: 'label' },
  onChange: () => null,
  disabled: false,
  error: '',
  isStepForm: false,
};

export default CustomSelectMaterialCore;
